import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { sleep } from "@/utils";
import { useCommonStore } from "@/stores";
import { FtLoading } from "@/components";

const Generating = () => {
  const { t } = useTranslation();
  const [textKey, setTextKey] = useState("generating1");
  const isMobile = useCommonStore(state => state.isMobile);

  useEffect(() => {
    (async () => {
      await sleep(2000);
      setTextKey("generating2");
      await sleep(2000);
      setTextKey("generating3");
    })()
  }, []);

  return (
    <FtLoading
      title={isMobile ? t("generating") : t(textKey)}
    ></FtLoading>
  )
}

export default Generating;